import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-content" }
const _hoisted_2 = { class: "body" }

import { computed, PropType, ref, watch } from 'vue';
import { default as ColourPicker } from '@/shared/services/color';
import { HomescreenAppInitViewModel } from '@/features/webassistant/models';
import HomeScreenHeader from './HomeScreenHeader.vue';
import HomeScreenPanelStartChat from './HomeScreenPanelStartChat.vue';
import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card } from '@/shared/components/cardRenderer';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeScreenPreview',
  props: {
  brandColour: {
    type: String,
    required: true,
  },
  actionColour: {
    type: String,
    required: true,
  },
  homescreenImageUrl: {
    type: String,
    default: '',
  },
  greetingText: {
    type: String,
  },
  introductionText: {
    type: String,
  },
  typicalResponseTime: {
    type: String,
  },
  homescreenApps: {
    type: Array as PropType<HomescreenAppInitViewModel[]>,
    default: [],
  },
},
  setup(__props) {

const props = __props;

const cards = ref<Card[]>([]);
const textColour = computed(() => ColourPicker.getContrastingColour(props.brandColour));

watch(
  () => props.homescreenApps,
  (value: HomescreenAppInitViewModel[]) => {
    cards.value = value.map((app) => ({ id: app.id, content: app.card }));
  },
);

function getDarkPrimary() {
  return ColourPicker.darken(props.brandColour, 12);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({
      background: `linear-gradient(90deg, ${__props.brandColour} 0%, ${getDarkPrimary()} 100%)`,
      color: textColour.value,
    }),
    class: "home-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HomeScreenHeader, {
        brandColour: __props.brandColour,
        homescreenImageUrl: __props.homescreenImageUrl,
        greetingText: __props.greetingText,
        introductionText: __props.introductionText
      }, null, 8, ["brandColour", "homescreenImageUrl", "greetingText", "introductionText"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HomeScreenPanelStartChat, {
          brandColour: __props.brandColour,
          actionColour: __props.actionColour,
          subtitle: __props.typicalResponseTime
        }, null, 8, ["brandColour", "actionColour", "subtitle"]),
        _createVNode(CardRenderer, {
          colour: __props.actionColour,
          cards: cards.value,
          location: 'homescreen'
        }, null, 8, ["colour", "cards"])
      ])
    ])
  ], 4))
}
}

})